var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeptTree',{attrs:{"items":_vm.items,"onExpand":_vm.handleExpand,"current":_vm.dept,"companies":_vm.companies,"userlang":_vm.userlang},on:{"selectDept":_vm.selectDept,"addDept":_vm.addDept,"selCompany":_vm.selectCompany}})
}
var staticRenderFns = []

export { render, staticRenderFns }